// extracted by mini-css-extract-plugin
export default {"modal":"AddModal_modal__sIXyE","modalContent":"AddModal_modalContent__p29yF","option":"AddModal_option__yIL3C","inputZ":"AddModal_inputZ__8wYuh","active":"AddModal_active__8o3qb"};